module.exports = __webpack_public_path__ + "img/1520065359.acb4d452.jpg";